import { EpicIcons } from "@constellation-academy/epic-ui";
import { Toast } from "primereact/toast";
import React, { useContext, useRef } from "react";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { createMessageDefinitionButton_CreateMessageDefinitionMutation } from "@relay/createMessageDefinitionButton_CreateMessageDefinitionMutation.graphql";
import { CREATE_MESSAGE_DEFINITION_MUTATION } from "./create-message-definition-button.graphql";
import { buttonWrapperClass } from "./create-message-definition-button.styles";
import { Button, ButtonVariant } from "../../../../../components/button";
import { MessageDefinitionsContext } from "../../../message-definitions.context";

export const CreateMessageDefinitionButton = () => {
	const { t } = useTranslation("common");
	const toast = useRef<Toast>(null);
	const { connectionId } = useContext(MessageDefinitionsContext);

	const [createMessageDefinition] =
		useMutation<createMessageDefinitionButton_CreateMessageDefinitionMutation>(
			CREATE_MESSAGE_DEFINITION_MUTATION,
		);

	const handleOnCreateClick = () => {
		createMessageDefinition({
			variables: {
				input: {
					internalTitle: t("messageDefinition.newTitle"),
				},
				connections: [connectionId],
			},
			onCompleted: () => {
				toast.current?.show({
					severity: "success",
					life: 3000,
					summary: t("messageDefinition.createdSummary"),
					detail: t("messageDefinition.createdDetail"),
				});
			},
			onError: () => {
				toast.current?.show({
					severity: "error",
					life: 3000,
					summary: t("messageDefinition.createErrorSummary"),
					detail: t("messageDefinition.createErrorDetail"),
				});
			},
		});
	};

	return (
		<>
			<Toast ref={toast}></Toast>
			<div className={buttonWrapperClass}>
				<Button
					icon={EpicIcons.FILE_EDIT}
					variant={ButtonVariant.Strong}
					label={t("messageDefinition.defineButton")}
					onClick={handleOnCreateClick}
				/>
			</div>
		</>
	);
};
